module.exports = __webpack_public_path__ + "static/img/024.099d369.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/datav-gejiachecun/024.png
// module id = pq6g
// module chunks = 1